import { FC } from 'react'
import { Box } from '../../core/Components'
import { Modal } from '../../core/Modal'
import { StudioSaveComponentBody, StudioSaveComponentBodyProps } from './StudioSaveComponent'

interface Props extends StudioSaveComponentBodyProps {
  trigger: JSX.Element
}

const StudioCloseDraftComponent: FC<Props> = (props) => (
  <Modal trigger={<Box>{props.trigger}</Box>}>
    <StudioSaveComponentBody {...props} userIsLeavingStudio={true} />
  </Modal>
)

export default StudioCloseDraftComponent
